import { Component, Vue, Watch } from 'vue-property-decorator'
import vSelect from 'vue-select'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt, faEdit, faRotate } from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'

import api from '@/helpers/fetch'
import Fuse from 'fuse.js'
let fuse = new Fuse([], {})

library.add(faTrashAlt, faEdit, faRotate)

@Component({
	components: {
		Loader,
		vSelect,
	},
})
export default class ContentPodcasts extends Vue {
	loading = false
	modalLoading = false
	savingTag = false
	filter = ''

	options = {
		podcasts: [] as Array<any>,
		tags: [] as Array<any>,
	}

	form = {
		id: '',
		title: '',
		desc: '',
		episode: '',
		season: '',
		image: '',
		duration: '',
		link: '',
		audio_url: '',
		audio_type: '',
		audio_length: '',
		content_tags: [] as Array<any>,
	}

	formTags = {
		id: '',
		tags: [] as Array<any>,
		tag: '',
	}

	get filteredOptions() {
		// @ts-ignore
		return this.filter.length
			? fuse.search(this.filter).map(({ item }) => item)
			: this.options.podcasts
	}

	fuseSearch(options, search) {
		const fuse = new Fuse(options, {
			keys: ['name'],
			shouldSort: true,
			ignoreLocation: true,
		})
		// @ts-ignore
		return search.length
			? fuse.search(search).map(({ item }) => item)
			: options
	}

	async loadContentPodcasts() {
		this.loading = true
		const res = await api.get('/api/blogging/content-podcasts')
		this.loading = false
		this.options.podcasts.length = 0
		this.options.podcasts.push(
			...res.data.map((option) => {
				Object.assign(option, { loading: false })
				option.content_tags = option.content_tags.map((tagMap) => {
					Object.assign(tagMap, { loading: false })
					return tagMap
				})
				return option
			}),
		)
		// @ts-ignore
		fuse = new Fuse(this.options.podcasts, {
			keys: ['title'],
		})
	}

	async loadContentTags() {
		this.loading = true
		const res = await api.get('/api/blogging/content-tags')
		this.loading = false
		this.options.tags.length = 0
		this.options.tags.push(...res.data)
	}

	async updatePodcastsList() {
		this.loading = true
		const res = await api.post('/api/blogging/content-podcasts', {})
		this.loading = false
		if (res.ok) {
			this.loadContentPodcasts()
		} else {
			this.$bvToast.toast(
				'Não foi possível atualizar a lista de podcasts',
				{
					title: 'Erro',
					variant: 'danger',
					solid: true,
					toaster: 'b-toaster-top-center',
				},
			)
		}
	}

	clearForm() {
		this.form.id = ''
		this.form.title = ''
		this.form.desc = ''
		this.form.episode = ''
		this.form.season = ''
		this.form.image = ''
		this.form.duration = ''
		this.form.link = ''
		this.form.audio_url = ''
		this.form.audio_type = ''
		this.form.audio_length = ''

		this.formTags.id = ''
		this.formTags.tag = ''
		this.formTags.tags = []
		this.modalLoading = false
	}

	openEdit(podcast) {
		this.form.id = podcast.id
		this.form.title = podcast.title
		this.form.desc = podcast.desc
		this.form.episode = podcast.episode
		this.form.season = podcast.season
		this.form.image = podcast.image
		this.form.duration = podcast.duration
		this.form.link = podcast.link
		this.form.audio_url = podcast.audio_url
		this.form.audio_type = podcast.audio_type
		this.form.audio_length = podcast.audio_length
		this.$bvModal.show('modal-edit-tag')
	}

	openLink(podcast) {
		this.formTags.id = podcast.id
		this.formTags.tags = podcast.content_tags || []
		this.$bvModal.show('modal-link')
	}

	async addTag() {
		if (!this.formTags.tag) return
		const tag = this.options.tags.find(
			(tag) => tag.id === this.formTags.tag,
		)

		this.savingTag = true
		const res = await api.post(
			'/api/blogging/content-podcasts/' +
				this.formTags.id +
				'/content-tags',
			{ tag: this.formTags.tag },
		)
		if (res.ok) {
			this.formTags.tags.push({
				mapId: res.data.id,
				tag: {
					name: tag.name,
					id: tag.id,
				},
				loading: false,
			})
			this.formTags.tag = ''
		} else {
			this.$bvToast.toast(
				'Não foi possível associar tag, verifique se a tag já não está associada',
				{
					title: 'Erro',
					variant: 'danger',
					solid: true,
					toaster: 'b-toaster-top-center',
				},
			)
		}
		this.savingTag = false
	}

	async removeTag(tagMap, index) {
		tagMap.loading = true
		const res = await api.delete(
			'/api/blogging/content-podcasts/' +
				this.formTags.id +
				'/content-tags',
			{ mapId: tagMap.mapId },
		)
		if (res.ok) {
			this.formTags.tags.splice(index, 1)
		}
		tagMap.loading = false
	}

	mounted() {
		this.$store.dispatch('saveCurrentFullPath', this.$route.fullPath)
		this.loadContentPodcasts()
		this.loadContentTags()
	}
}
